import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { StyledTableCell, StyledTableRow } from './CustomStyles/StyledTable';
import { SummaryHeadings } from './SummaryConstants';

function createData(name, values) {
  return { name, values };
}

export default function ViewSummary(props) {
  const rows = [
    createData('Office hours', props.officeHours),
    createData('Work from home hours', props.wfhHours),
    createData('Remote office hours', props.remoteOfficeHours),
    createData('External hours', props.externalHours),
    createData('Client office hours', props.clientOfficeHours),
    createData('Work travel hours', props.workTravelHours),
    createData('Weekend working hours', props.weekendWorkingHours),
    createData('Total work hours', props.totalHours),
    createData('Expected hours', props.expectedHours),
  ];

  return (
    <>
      <div>
        <Typography
          variant="h6"
          component="h5"
          align="center"
          gutterBottom
          style={{ margin: '7px 0', color: '#4d6cd9' }}
        >
          Summary
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 300 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell
                  style={{
                    backgroundColor: '#4d6cd9',
                    color: 'white',
                    fontWeight: 'bold',
                  }}
                >
                  Type
                </StyledTableCell>
                {rows.map((row) => (
                  <StyledTableCell
                    key={row.name}
                    style={{
                      backgroundColor: '#4d6cd9',
                      color: 'white',
                      fontWeight: 'bold',
                    }}
                    align="center"
                  >
                    {row.name}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Second Row for "Hours" */}
              <TableRow>
                <StyledTableCell
                  style={{
                    // backgroundColor: '#dbe2ef',
                    fontWeight: 'bold',
                    color: '#333',
                  }}
                >
                  Hours
                </StyledTableCell>
                {rows.map((row) => (
                  <StyledTableCell key={row.name} align="center">
                    {row.values}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}
